//================== Share Types =============//

export const SHARE_TYPE = {
  NORMAL : 'share_normal',
  REGISTER : 'share_register',
  TOPUP : 'share_topup',
  POCKET_MONEY : 'share_pocket_money',
  SPIN : 'share_spin',
  WITHDRAW : 'share_withdraw',
}